import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import { Http } from '@angular/http';
import { AdminSound } from '../models/AdminSound';
import { SwitchStatusTimes } from '../models/SwitchStatusTimes';
import { StatusEndTimeRules } from '../models/StatusEndTimeRules';

@Injectable()
export class StatusEndTimeRulesService {
  constructor(private http: Http) {}

  get(regionId: number, skip: number, take: number): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.statusEndTimeRules.get
        .replace('{regionId}', regionId.toString())
        .replace('{skip}', skip.toString())
        .replace('{take}', take.toString());
    return this.http.get(url).map(res => {
      return res.json().map(j => new StatusEndTimeRules(j));
    });
  }

  count(regionId: number): Observable<number> {
    const url =
      environment.api.baseUrl +
      environment.api.statusEndTimeRules.count.replace(
        '{regionId}',
        regionId.toString()
      );
    return this.http.get(url).map(res => {
      return +res.text();
    });
  }

  save(status: StatusEndTimeRules): Observable<StatusEndTimeRules> {
    const url =
      environment.api.baseUrl + environment.api.statusEndTimeRules.save;
    return this.http.put(url, status).map(res => {
      return res.json();
    });
  }

  add(status: StatusEndTimeRules): Observable<any> {
    const url =
      environment.api.baseUrl + environment.api.statusEndTimeRules.add;
    return this.http.post(url, status).map(res => {
      return res.json();
    });
  }

  delete(
    statusId: number,
    categoryId: number,
    regionId: number
  ): Observable<any> {
    const url =
      environment.api.baseUrl +
      environment.api.statusEndTimeRules.delete
        .replace('{statusId}', statusId.toString())
        .replace('{regionId}', regionId.toString())
        .replace('{categoryId}', categoryId.toString());
    return this.http.delete(url).map(res => {
      return res;
    });
  }
}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/shared/services/status-end-time-rules.service.ts